var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSegmentationDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.6134H8.93333C9.36667 10.6134 9.72667 10.2267 9.72667 9.76005C9.72667 9.18005 9.52 9.06671 9.18 8.94671L8.50667 8.71338V10.6134H8.5Z",
    fill: "#A4A7AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98021 1.26661C4.30021 1.27995 1.32021 4.27328 1.33354 7.95328C1.34687 11.6333 4.34021 14.6133 8.02021 14.5999C11.7002 14.5866 14.6802 11.5933 14.6669 7.91328C14.6535 4.23328 11.6602 1.25995 7.98021 1.26661ZM9.50687 7.99995C10.0269 8.17995 10.7269 8.56661 10.7269 9.75995C10.7269 10.7866 9.92021 11.6133 8.93354 11.6133H8.50021V11.9999C8.50021 12.2733 8.27354 12.4999 8.00021 12.4999C7.72687 12.4999 7.50021 12.2733 7.50021 11.9999V11.6133H7.26021C6.16687 11.6133 5.28021 10.6933 5.28021 9.55995C5.28021 9.28661 5.50687 9.05995 5.78021 9.05995C6.05354 9.05995 6.28021 9.28661 6.28021 9.55995C6.28021 10.1399 6.72021 10.6133 7.26021 10.6133H7.50021V8.35995L6.49354 7.99995C5.97354 7.81995 5.27354 7.43328 5.27354 6.23995C5.27354 5.21328 6.08021 4.38661 7.06687 4.38661H7.50021V3.99995C7.50021 3.72661 7.72687 3.49995 8.00021 3.49995C8.27354 3.49995 8.50021 3.72661 8.50021 3.99995V4.38661H8.74021C9.83354 4.38661 10.7202 5.30661 10.7202 6.43995C10.7202 6.71328 10.4935 6.93995 10.2202 6.93995C9.94687 6.93995 9.72021 6.71328 9.72021 6.43995C9.72021 5.85995 9.28021 5.38661 8.74021 5.38661H8.50021V7.63995L9.50687 7.99995Z",
    fill: "#A4A7AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27979 6.24672C6.27979 6.82672 6.48645 6.94005 6.82645 7.06005L7.49978 7.29339V5.38672H7.06645C6.63312 5.38672 6.27979 5.77339 6.27979 6.24672Z",
    fill: "#A4A7AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentationDollar);
export default __webpack_public_path__ + "static/media/segmentation_dollar.ac43d02501db163f942ef86d28d35e06.svg";
export { ForwardRef as ReactComponent };